import '@fontsource-variable/bricolage-grotesque'
import '@fontsource-variable/montserrat'
import { AppUpdateToast } from '@gozoki/ui/components/app-update/app-update-toast'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools'
import { type QueryClient, useQuery } from '@tanstack/react-query'
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import NotFoundPage from '~/components/communication/NotFoundPage'
import { ExportJobsWatcher } from '~/components/new/exports/export-jobs-watcher'
import { MfaEnrollmentGate } from '~/components/routes/account-security/mfa-enrollment-gate'
import { adminMfaStatusQueryOptions } from '~/components/routes/account-security/mfa-status-query'
import { Toaster } from '~/components/ui/sonner'
import '~/lib/zod-errors'
import FliptProvider from '../components/FliptProvider'
import GlobalProvider from '../components/GlobalProvider'
import VisioComponent from '../components/VisioComponent'

interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootDocument,
  notFoundComponent: NotFoundPage,
})

function RootDocument() {
  // État du double facteur amorcé ici, en même temps que l'identité : `GlobalProvider` ne rend ses
  // enfants, dont la garde qui le lit, qu'après `/admin/me` et les droits.
  useQuery(adminMfaStatusQueryOptions())

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <FliptProvider>
        <GlobalProvider>
          <MfaEnrollmentGate>
            <Outlet />
          </MfaEnrollmentGate>
          <TanStackDevtools
            plugins={[
              {
                name: 'TanStack Router',
                render: <TanStackRouterDevtoolsPanel />,
              },
              { name: 'TanStack Query', render: <ReactQueryDevtoolsPanel /> },
              formDevtoolsPlugin(),
            ]}
          />
          <VisioComponent />
          {/* Exports lancés depuis l'onglet : suivis jusqu'au téléchargement, d'un écran à l'autre,
              y compris hors du layout authentifié (pointage `_nosidebar`, qui a aussi la cloche). */}
          <ExportJobsWatcher />
          <Toaster
            richColors
            position="bottom-center"
            toastOptions={{ style: { width: '600px' } }}
          />
          <AppUpdateToast enabled={import.meta.env.PROD} />
        </GlobalProvider>
      </FliptProvider>
    </LocalizationProvider>
  )
}
